import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import ReactPlayer from 'react-player'
import ResourcesList from '../subcomponents/ResourcesList'

import './CurriculumDetailModal.scss'

class CurriculumDetailModal extends React.Component {
  state = {
    selectedObjective: 0,
  }
  render() {
    const { selectedObjective } = this.state
    const { subject, close, hasSideNav, t } = this.props
    return (
      <div id='CurriculumDetailModal'>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div className='grey-out' onClick={close} />
        <div
          className={`curriculum-detail-modal-content ${
            hasSideNav ? 'hasSideNav' : ''
          }`}
        >
          <div className='modal-preview-bar'>
            <div
              className='top-photo'
              style={{ backgroundImage: `url(${subject.photo.file_url || subject.photo.fileUrl})` }}
            >
              <div
                className='subject-icon'
                style={{ backgroundImage: `url(${subject.icon.file_url || subject.icon.fileUrl})` }}
              />
            </div>
            <div className='title-bar'>
              <p className='subject-title'>{subject.name}</p>
              <p className='subject-subtitle'>{t('lessonPlans.curriculumDetailModal.subjectSubtitle', { name: subject.name })}</p>
            </div>
            <div className='objective-list-view'>
              {subject.objectives.map((objective, index) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                <div
                  key={index}
                  className={`objective-preview-bar ${
                    index === selectedObjective && 'selected-objective'
                  }`}
                  onClick={() => this._selectObjective(index)}
                >
                  <div
                    className='subject-icon-detail'
                    style={{
                      backgroundImage: `url(${subject.icon.file_url || subject.icon.fileUrl})`,
                      backgroundColor: objective.rank.color_hex || objective.rank.colorHex,
                    }}
                  />
                  <div className='objective-preview-text'>
                    <p className='objective-preview-title'>
                      {this._titleCase(objective.name.toLowerCase())}
                    </p>
                    <p className='objective-preview-subtitle'>
                      {t('lessonPlans.curriculumDetailModal.levelLabel', {
                        level: index + 1,
                        rankName: objective.rank.name,
                      })}
                    </p>
                  </div>
                  <i className='fa fa-angle-right' aria-hidden='true' />
                </div>
              ))}
            </div>
          </div>
          <div className='object-view-area'>
            <div className='exit-container'>
              <i className='fa fa-times' aria-hidden='true' onClick={close} />
            </div>
            <div className='objective-video-container'>
              <ReactPlayer
                className='objective-modal-react-player'
                url={subject.objectives[selectedObjective].video.attachment_url || subject.objectives[selectedObjective].video.attachmentUrl}
                width='100%'
                height='240px'
                controls
              />
            </div>
            <div className='objective-view-title-area-container'>
              <div
                className='objective-icon-detail'
                style={{
                  backgroundImage: `url(${subject.icon.file_url || subject.icon.fileUrl})`,
                  backgroundColor:
                    subject.objectives[selectedObjective].rank.color_hex || subject.objectives[selectedObjective].rank.colorHex,
                }}
              />
              <div className='objective-view-title-area'>
                <p className='objective-detail-title'>
                  {this._titleCase(
                    subject.objectives[selectedObjective].name.toLowerCase()
                  )}
                </p>
                <p className='objective-detail-subtitle'>
                  {t('lessonPlans.curriculumDetailModal.levelLabel', {
                    level: selectedObjective + 1,
                    rankName: subject.objectives[selectedObjective].rank.name,
                  })}
                </p>
              </div>
            </div>
            <p>{subject.objectives[selectedObjective].description}</p>
            <div className='objective-resources-container'>
              <div className='objective-resources-box'>
                <p className='resource-section-title'>{t('lessonPlans.curriculumDetailModal.resources')}</p>
                {subject.objectives[selectedObjective]?.links?.length > 0 ?
                  <ResourcesList links={subject.objectives[selectedObjective].links}/>
                  :
                  <div className='no-resource-placeholder'>
                    <p> {t('lessonPlans.curriculumDetailModal.noResources')} </p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _selectObjective = (index) => {
    this.setState({ selectedObjective: index })
  }

  _titleCase = (str) => {
    const sentence = str.split(' ')
    let newStr = ''
    sentence.forEach((word) => {
      const newWord = word[0].toUpperCase() + word.slice(1)
      newStr += newWord + ' '
    })
    return newStr
  }
}

CurriculumDetailModal.propTypes = {
  t: PropTypes.func,
  close: PropTypes.func,
  hasSideNav: PropTypes.bool,
  subject: PropTypes.shape({
    name: PropTypes.string,
    photo: PropTypes.shape({
      file_url: PropTypes.string,
      fileUrl: PropTypes.string,
    }),
    icon: PropTypes.shape({
      file_url: PropTypes.string,
      fileUrl: PropTypes.string,
    }),
    objectives: PropTypes.array,
  }),
}

export default withTranslation()(CurriculumDetailModal)
